/**
 * @generated SignedSource<<f0bbfe03a4984aed0d89b768a4fb0984>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImagesTabImageRecordsQuery$variables = {
  assetId: string;
};
export type ImagesTabImageRecordsQueryVariables = ImagesTabImageRecordsQuery$variables;
export type ImagesTabImageRecordsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ImagesTabImagesList_imageRecords">;
};
export type ImagesTabImageRecordsQueryResponse = ImagesTabImageRecordsQuery$data;
export type ImagesTabImageRecordsQuery = {
  variables: ImagesTabImageRecordsQueryVariables;
  response: ImagesTabImageRecordsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetId"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v2 = [
  {
    "kind": "Variable",
    "name": "assetId",
    "variableName": "assetId"
  },
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImagesTabImageRecordsQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ImagesTabImagesList_imageRecords"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImagesTabImageRecordsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ImageRecordConnection",
        "kind": "LinkedField",
        "name": "imageRecordsByAsset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageRecordEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageRecord",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganizationUser",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "assetId"
        ],
        "handle": "connection",
        "key": "ImageRecordList_imageRecordsByAsset",
        "kind": "LinkedHandle",
        "name": "imageRecordsByAsset"
      }
    ]
  },
  "params": {
    "cacheID": "38bed9bce1fe95c7aaa01cae03d792b4",
    "id": null,
    "metadata": {},
    "name": "ImagesTabImageRecordsQuery",
    "operationKind": "query",
    "text": "query ImagesTabImageRecordsQuery(\n  $assetId: ID!\n) {\n  ...ImagesTabImagesList_imageRecords_4i7Unr\n}\n\nfragment ImageItem_imageRecord on ImageRecord {\n  id\n  createdAt\n  author {\n    id\n    firstName\n    lastName\n  }\n  imageUrl\n}\n\nfragment ImagesTabImagesList_imageRecords_4i7Unr on Query {\n  imageRecordsByAsset(assetId: $assetId, first: 10) {\n    edges {\n      node {\n        id\n        ...ImageItem_imageRecord\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eec161bc3053e0ed335e4227af939e24";

export default node;
